/**
 * Onboarding flow constants
 * Defines the order and step numbers for authenticated onboarding screens
 */

/** AsyncStorage: first `completeOnboarding()` on this install (ms) — drives marketing-upsell deferral. */
export const STORAGE_ONBOARDING_COMPLETED_AT_MS = '@tripvio_onboarding_completed_at_ms';

export const ONBOARDING_SCREENS = [
  'profile-details',
  'avatar',
  'travel-type',
  'first-trip',
] as const;

// Bump this to force showing the value-prop screen again after changes.
export const VALUE_PROP_REVISION = '2025-12-ios-refresh-3';

export type OnboardingScreenName = typeof ONBOARDING_SCREENS[number];

/**
 * Get the step number for a given onboarding screen route name
 * @param routeName - The route name (e.g., 'email-sync', 'profile-details')
 * @returns The step number (1-based) or null if not found
 */
export function getOnboardingStep(routeName: string): number | null {
  const index = ONBOARDING_SCREENS.findIndex((screen) => routeName.includes(screen));
  return index >= 0 ? index + 1 : null;
}

/**
 * Get the total number of onboarding steps
 */
export function getTotalOnboardingSteps(): number {
  return ONBOARDING_SCREENS.length;
}















